<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('floatingCashier.pageTitle') }}</h1>
      <ts-breadcrumb :items="[
        { text: $t('home'), href: '/' },
        {
          text: $t('floatingCashier.pageTitle'),
          active: true
        }
      ]" />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="d-flex justify-content-between">
          <ts-button outline color="info" @click.prevent="addNew">
            {{ $t('add_new') }}
          </ts-button>
          <div class="d-flex ts-items-center ts-space-x-3">
            <Input search v-model="search" :placeholder="$t('floatingCashier.search')" :style="width"
              @on-focus="() => (width = 'width: 500px')" @on-blur="() => (width = 'width: 300px')" />
            <!-- <ts-filter ref="filter">
            </ts-filter> -->
          </div>
        </div>
      </ts-card-wrapper>
      <div class="overflow-auto">
        <Table :columns="columns" :data="resources" size="small" :loading="loading" highlight-row stripe
          max-height="700" border>
          <template slot-scope="{ row }" slot="opening_usd_balance">
            <div>
              <ts-display-currency :amount="row.opening_usd_balance ? row.opening_usd_balance : 0" :currency_id="1" />
            </div>
          </template>
          <template slot-scope="{ row }" slot="closing_usd_balance">
            <div>
              <ts-display-currency :amount="row.closing_usd_balance ? row.closing_usd_balance : 0" :currency_id="1" />
            </div>
          </template>
          <template slot-scope="{ row }" slot="opening_khr_balance">
            <div>
              <ts-display-currency :amount="row.opening_khr_balance ? row.opening_khr_balance : 0" :currency_id="2" />
            </div>
          </template>
          <template slot-scope="{ row }" slot="closing_khr_balance">
            <div>
              <ts-display-currency :amount="row.closing_khr_balance ? row.closing_khr_balance : 0" :currency_id="2" />
            </div>
          </template>
          <template slot-scope="{ row }" slot="cash_usd_in">
            <div>
              <ts-display-currency :amount="row.cash_usd_in ? row.cash_usd_in : 0" :currency_id="1" />
            </div>
          </template>
          <template slot-scope="{ row }" slot="cash_usd_out">
            <div>
              <ts-display-currency :amount="row.cash_usd_out ? row.cash_usd_out : 0" :currency_id="1" />
            </div>
          </template>
          <template slot-scope="{ row }" slot="cash_khr_in">
            <div>
              <ts-display-currency :amount="row.cash_khr_in ? row.cash_khr_in : 0" :currency_id="2" />
            </div>
          </template>
          <template slot-scope="{ row }" slot="cash_khr_out">
            <div>
              <ts-display-currency :amount="row.cash_khr_out ? row.cash_khr_out : 0" :currency_id="2" />
            </div>
          </template>
          <template slot-scope="{ row }" slot="opening_member_card">
            <div>
              <b class="ts-text-blue-700">
                {{ row.opening_member_card ? row.opening_member_card : 0 }}
              </b>
            </div>
          </template>
          <template slot-scope="{ row }" slot="closing_member_card">
            <div>
              <b class="ts-text-blue-700">
                {{ row.closing_member_card ? row.closing_member_card : 0 }}
              </b>
            </div>
          </template>
          <template slot-scope="{ row }" slot="member_card_in">
            <div>
              <b class="ts-text-blue-700">
                {{ row.member_card_in ? row.member_card_in : 0 }}
              </b>
            </div>
          </template>
          <template slot-scope="{ row }" slot="member_card_out">
            <div>
              <b class="ts-text-blue-700">
                {{ row.member_card_out ? row.member_card_out : 0 }}
              </b>
            </div>
          </template>
          <template slot-scope="{ row }" slot="action">
            <a href="#" v-tooltip="$t('edit')" class="text-primary mr-2" @click.prevent="edit(row)">
              <i class="fas fa-edit"></i>
            </a>
            <a-popconfirm placement="leftTop" :title="$t('are_you_sure_to_delete')" :ok-text="$t('yes')"
              :cancel-text="$t('no')" @confirm="deleteRecord(row)">
              <a href="#" :disabled="row._deleting">
                <i class="fas fa-circle-notch spin" v-if="row._deleting"></i>
                <i class="fa fa-trash text-red" v-else></i>
              </a>
            </a-popconfirm>
          </template>
        </Table>
        <div class="d-flex justify-content-between align-items-center p-15">
          <ts-total-list v-model="pagination" />
          <ts-pagination v-model="pagination" @navigate="fetchData"></ts-pagination>
        </div>
        <a-modal v-if="showForm" v-model="showForm" draggable sticky scrollable :mask="false" :footer="null"
          width="650px" :z-index="1022" :title="$t('floatingCashier.pageTitle')" @cancel="clearEdit">
          <from-action ref="form_action" @cancel="clearEdit" @fetchData="fetchData" />
        </a-modal>
      </div>
    </ts-card>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import FromAction from './form.vue'
import { debounce } from 'lodash'
import expandRow from './table-expand.vue'

export default {
  name: 'floating-cashier',
  components: {
    FromAction
  },
  data() {
    return {
      loading: false,
      showForm: false,
      width: 'width: 300px',
      categories: [],
      groups: [],
      model: {}
    }
  },
  computed: {
    ...mapState('floating/floatingCashier', ['resources', 'pagination', 'formViewDatas']),
    search: {
      get() {
        return this.$store.state.floating.floatingCashier.search
      },
      set(newValue) {
        this.$store.commit(
          'floating/floatingCashier/SET_SEARCH',
          newValue
        )
        this.$store.commit(
          'floating/floatingCashier/RESET_CURRENT_PAGE'
        )
      }
    },
    columns() {
      return [
        {
          type: 'expand',
          render: (h, params) => {
            return h(expandRow, {
              props: {
                row: params.row
              }
            })
          },
          width: 30
        },
        {
          title: this.$t('floatingCashier.branch'),
          key: 'branch_name_en',
          width: 130
        },
        {
          title: this.$t('floatingCashier.floatingDate'),
          key: 'floating_date',
          width: 170
        },
        {
          title: this.$t('floatingCashier.cashier'),
          key: 'cashier_name',
          width: 140
        },

        {
          title: this.$t('floatingCashier.khr'),
          align: 'center',
          children: [
            {
              title: this.$t('floatingCashier.opening'),
              slot: 'opening_khr_balance',
              align: 'center',
              minWidth: 130
            },
            {
              title: this.$t('floatingCashier.closing'),
              slot: 'closing_khr_balance',
              align: 'center',
              minWidth: 130
            },
            {
              title: this.$t('floatingCashier.in'),
              slot: 'cash_khr_in',
              align: 'center',
              minWidth: 130
            },
            {
              title: this.$t('floatingCashier.out'),
              slot: 'cash_khr_out',
              align: 'center',
              minWidth: 130
            },
          ]
        },
        {
          title: this.$t('floatingCashier.usd'),
          align: 'center',
          children: [
            {
              title: this.$t('floatingCashier.opening'),
              slot: 'opening_usd_balance',
              align: 'center',
              minWidth: 130
            },
            {
              title: this.$t('floatingCashier.closing'),
              slot: 'closing_usd_balance',
              align: 'center',
              minWidth: 130
            },
            {
              title: this.$t('floatingCashier.in'),
              slot: 'cash_usd_in',
              align: 'center',
              minWidth: 130
            },
            {
              title: this.$t('floatingCashier.out'),
              slot: 'cash_usd_out',
              align: 'center',
              minWidth: 130
            },
          ]
        },
        {
          title: this.$t('floatingCashier.memberShipCard'),
          align: 'center',
          children: [
            {
              title: this.$t('floatingCashier.opening'),
              slot: 'opening_member_card',
              align: 'center',
              minWidth: 130
            },
            {
              title: this.$t('floatingCashier.closing'),
              slot: 'closing_member_card',
              align: 'center',
              minWidth: 130
            },
            {
              title: this.$t('floatingCashier.in'),
              slot: 'member_card_in',
              align: 'center',
              minWidth: 130
            },
            {
              title: this.$t('floatingCashier.out'),
              slot: 'member_card_out',
              align: 'center',
              minWidth: 130
            },
          ]
        },
        {
          title: this.$t('floatingCashier.remark'),
          key: 'remark',
          width: 180,
        },
        {
          title: this.$t('floatingCashier.createdBy'),
          key: 'created_by_name',
          width: 130,
        },
        {
          title: this.$t('floatingCashier.createdDate'),
          key: 'created_date',
          minWidth: 180,
        },
        {
          title: this.$t('actions'),
          key: 'action',
          slot: 'action',
          fixed: 'right',
          align: 'center',
          width: 94
        }
      ]
    }
  },
  created() { },
  methods: {
    ...mapActions('floating/floatingCashier', ['getFormViewModel']),
    async getPreData() {
      await this.getFormViewModel({ index: undefined, params: {} })
    },
    addNew() {
      this.showForm = true
    },
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('floating/floatingCashier/fetch', attributes)
        .catch(error => {
          this.loading = false
          this.notice({ type: 'error', text: error.message })
        })
        .finally(() => {
          this.loading = false
        })
    },
    edit(record) {
      this.showForm = true
      this.$store.commit('floating/floatingCashier/SET_EDIT_DATA', record)
    },
    clearEdit() {
      console.log('sad');

      this.$store.commit('floating/floatingCashier/SET_EDIT_DATA', {})
      this.showForm = false
    },
    deleteRecord(record) {
      record._deleting = true
      this.$store
        .dispatch('floating/floatingCashier/destroy', record.floating_id)
        .then(response => {
          this.$toasted.success(response.message)
          this.fetchData()
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          record._deleting = false
        })
    },
    notice(not) {
      this.$Notice[not.type]({
        title: 'FLOATING CASHIER',
        desc: not.text
      })
    }
  },
  watch: {
    search: debounce(function (search) {
      this.fetchData({ search })
    }, 500)
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.getPreData()
      vm.fetchData()
    })
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('floating/floatingCashier/RESET_STATE')
    next()
  }
}
</script>
